export const ACTION_TYPES = {
	updateParent: "UPDATE_PARENT",
	update: "UPDATE",
	delete: "DELETE",
	add: "ADD",
};
